require("-!style!css!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Affix.vue")
module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Affix.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Affix.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/Affix.vue
 ** module id = 81
 ** module chunks = 0
 **/